// extracted by mini-css-extract-plugin
export default {"container":"BaseCard_container__kxJdf","defaultContainer":"BaseCard_defaultContainer__mF-M7","secondaryContainer":"BaseCard_secondaryContainer__siFWJ"};